import { WithRequiredProperties } from "@common/types/base/generics";
import { TransactionsFilters } from "../filters/lib";
import { transferMatchingQueryKeys } from "../../documents/lib";
import { queryClient } from "../../../queryClient";

export async function invalidateTransactionsForTransferMatchingQueries(
    filters?: WithRequiredProperties<TransactionsFilters, "entityIds">,
    exact: boolean = false,
) {
    if (filters) {
        await queryClient.invalidateQueries({
            queryKey: transferMatchingQueryKeys.list(filters),
            exact,
        });
    } else {
        await queryClient.invalidateQueries({
            queryKey: transferMatchingQueryKeys.all(),
        });
    }
}
